import * as React from 'react';
import { useIntl } from 'gatsby-plugin-react-intl'
import { useStaticQuery, graphql } from "gatsby"
import { SunHeronFeatures } from "./SunHeronFeatures";

export const SunheronFeaturesWrapper = () => {
    const intl = useIntl()
    const data: {
        siteFeaturesJson: {
            firstText: string,
            firstTitle: string,
            secondText: string,
            secondTitle: string,
            thirdText: string,
            thirdTitle: string
        }
    } = useStaticQuery(graphql`
    {
      siteFeaturesJson {
    firstText
    firstTitle
    secondText
    secondTitle
    thirdText
    thirdTitle
  }
    }
  `)
    return (<div className="row m--auto fp__features">
        <SunHeronFeatures featureTitle={data.siteFeaturesJson.firstTitle}
            featureBody={data.siteFeaturesJson.firstText}
            imageIlustrationType='weather-data'
        />
        <SunHeronFeatures featureTitle={data.siteFeaturesJson.secondTitle}
            featureBody={data.siteFeaturesJson.secondText}
            offset={28}
            imageIlustrationType='globe'
        />
        <SunHeronFeatures featureTitle={data.siteFeaturesJson.thirdTitle}
            featureBody={data.siteFeaturesJson.thirdText}
            offset={34}
            imageIlustrationType={'target_pin'}
        />
    </div>)
}